module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title-center"
  }, [_vm._v("Dedication")]), _vm._v(" "), _c('p', {
    staticClass: "para-center"
  }, [_vm._v("Dedicated to my mother and father for their extraordinary love and support")]), _vm._v(" "), _c('p', {
    staticClass: "para-center"
  }, [_vm._v("In memory of Marshall T. Meyer whose spirituality touched so many lives")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a7eb432","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780025492659f01.vue
// module id = 63
// module chunks = 0